export default "__VITE_ASSET__DegkaSi4__"